import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useSettingRetailerEnableStandardizeOrderNumbers } from "@faire/help-center-utils/settings/useSettingRetailerEnableStandardizeOrderNumbers";
import {
  orderNumber as extractBrandOrderNumber,
  orderNumber as extractOrderNumber,
} from "@faire/web--source/common/tokenUtil";

import { useSelectedBrandOrder } from "./useSelectedBrandOrder";

export const useDisplayedOrderNumber = () => {
  const { selectedBrandOrder } = useSelectedBrandOrder();
  const { brand_order } = selectedBrandOrder ?? {};
  const orderNumber = brand_order?.order_items?.[0]?.order_token
    ? extractOrderNumber(brand_order?.order_items?.[0]?.order_token)
    : undefined;
  const brandOrderNumber = brand_order?.token
    ? extractBrandOrderNumber(brand_order?.token)
    : undefined;
  const useOrderNumber = !useSettingRetailerEnableStandardizeOrderNumbers();
  return isRetailer() && useOrderNumber ? orderNumber : brandOrderNumber;
};
